import {findTexture} from "./pixi-extensions";

export class UINineSlice extends PIXI.NineSlicePlane {

    constructor(texture, ...args) {
        texture = findTexture(texture);
        if (args.length === 0) {
            // Use central 1px lines to stretch
            let w = Math.max(0, Math.ceil(texture.width * 0.5) - 1);
            let h = Math.max(0, Math.ceil(texture.height * 0.5) - 1);
            args.push(w, h, w, h);
        }
        super(findTexture(texture), ...args);
        this.Active = false;
        this.HideWithBackButton = false;
        this.Awake();
    }

    setImage(texture) {
        this.texture = findTexture(texture);
    }

    fitLayout(rect) {
        this.position.copyFrom(rect);
        this.width = rect.width;
        this.height = rect.height;
    }

}
